import React, { useState, useEffect } from "react";
import Slot from "./Slot";
import "./StreamPlan.css";
import mockSchedule from "../mocks/schedule.mock.json"; // Mock Daten

function StreamPlan() {
  const [data, setData] = useState([]);
  const [error] = useState(null);
  const [showShortsButton, setShowShortsButton] = useState(false);

  const useMock = process.env.REACT_APP_USE_MOCK === "false";

  useEffect(() => {
    if (useMock) {
      const groupedByDate = groupSlotsByDate(mockSchedule.segments);
      setData(groupedByDate);
      return;
    }

    fetch("/schedule")
      .then((res) => {
        if (!res.ok) throw new Error(`Fetch error ${res.status}`);
        return res.json();
      })
      .then((json) => {
        if (json.segments) {
          const groupedByDate = groupSlotsByDate(json.segments);
          setData(groupedByDate);
        } else {
          setData([]);
        }
      })
      .catch((err) => {
        console.warn("API Fehler, fallback auf Mock:", err);
        const groupedByDate = groupSlotsByDate(mockSchedule.segments);
        setData(groupedByDate);
      });
  }, [useMock]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowShortsButton(true);
    }, 60000); // 1 Minute = 60000ms

    return () => clearTimeout(timer);
  }, []);

  const handleShortsClick = (e) => {
    e.preventDefault();
    window.open(
      "https://www.youtube.com/shorts",
      "youtube_shorts",
      "width=800,height=1000,left=100,top=100,resizable=yes,scrollbars=yes",
    );
  };
  const groupSlotsByDate = (segments) => {
    const grouped = {};

    segments.forEach((segment) => {
      const date = new Date(segment.start_time);
      const dateKey = date.toLocaleDateString("de-DE");

      if (!grouped[dateKey]) {
        grouped[dateKey] = {
          date: dateKey,
          weekday: date.toLocaleDateString("de-DE", { weekday: "long" }),
          slots: [],
        };
      }

      grouped[dateKey].slots.push({
        title: segment.title || "Stream",
        time: segment.start_time,
        link: "https://www.twitch.tv/sarahnokumo",
        imageUrl: segment.category_box_art_url || "",
        category: segment.category,
        id: segment.id,
      });
    });

    // Sortiere Slots innerhalb jedes Tages nach Zeit
    Object.values(grouped).forEach((dayGroup) => {
      dayGroup.slots.sort((a, b) => new Date(a.time) - new Date(b.time));
    });

    return Object.values(grouped);
  };

  if (error) {
    return <div>Fehler beim Laden: {error.message}</div>;
  }

  return (
    <main>
      <section>
        <div className="slots">
          {data.map((dayGroup, i) => (
            <Slot key={dayGroup.date} dayGroup={dayGroup} />
          ))}
        </div>
      </section>
      {showShortsButton && (
        <button
          onClick={handleShortsClick}
          className="shorts-button"
          title="Langeweile?"
        >
          📺
        </button>
      )}
    </main>
  );
}

export default StreamPlan;
